import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navRef = useRef(null);
    const isActive = (path) => location.pathname === path;

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        if (isMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isMenuOpen]);

    return (
        <nav ref={navRef} className="flex items-center justify-between px-6 py-4 bg-white/80 backdrop-blur-md border-b border-black/5 sticky top-0 z-[100] transition-all duration-300">
            {/* Left: Logo */}
            <div className="flex items-center gap-10">
                <Link to="/" className="flex items-center gap-2.5 no-underline group">
                    <img src="/logo no bg.png" alt="CarFido Logo" className="w-8 h-8 object-contain group-hover:rotate-[10deg] transition-transform duration-500" />
                    <span className="font-bold text-lg text-black tracking-tight">CarFido</span>
                </Link>

                {/* Center: Desktop Nav Links */}
                <ul className="hidden md:flex items-center gap-6 m-0 p-0 list-none">
                    <li>
                        <Link to="/about" className={`text-sm font-bold transition-all duration-300 ${isActive('/about') ? 'text-[#1F1F1F] underline decoration-[#D81F26] decoration-2 underline-offset-[6px]' : 'text-[#414141]/75 no-underline hover:text-[#1F1F1F]'}`}>
                            About
                        </Link>
                    </li>
                    <li>
                        <Link to="/blogs" className={`text-sm font-bold transition-all duration-300 ${isActive('/blogs') ? 'text-[#1F1F1F] underline decoration-[#D81F26] decoration-2 underline-offset-[6px]' : 'text-[#414141]/75 no-underline hover:text-[#1F1F1F]'}`}>
                            Blogs
                        </Link>
                    </li>
                    <li>
                        <Link to="/partner" className={`text-sm font-bold transition-all duration-300 ${isActive('/partner') ? 'text-[#1F1F1F] underline decoration-[#D81F26] decoration-2 underline-offset-[6px]' : 'text-[#414141]/75 no-underline hover:text-[#1F1F1F]'}`}>
                            Partners
                        </Link>
                    </li>
                    <li>
                        <Link to="/contact" className={`text-sm font-bold transition-all duration-300 ${isActive('/contact') ? 'text-[#1F1F1F] underline decoration-[#D81F26] decoration-2 underline-offset-[6px]' : 'text-[#414141]/75 no-underline hover:text-[#1F1F1F]'}`}>
                            Contact
                        </Link>
                    </li>
                </ul>
            </div>

            {/* Right: CTA */}
            <div className="flex items-center gap-4">
                <Link
                    to="/chat"
                    className="hidden md:flex px-5 py-2 bg-[#D81F26] text-white rounded-full text-xs font-bold no-underline hover:bg-[#B8181E] hover:scale-[1.02] active:scale-95 transition-all duration-300 shadow-[0_6px_16px_rgba(216,31,38,0.22)]"
                >
                    Try CarFido
                </Link>

                {/* Mobile Menu Button */}
                <button
                    onClick={toggleMenu}
                    className="md:hidden w-9 h-9 flex flex-col items-center justify-center gap-1.5 focus:outline-none bg-black/5 rounded-full"
                >
                    <span className={`w-4 h-0.5 bg-black transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                    <span className={`w-4 h-0.5 bg-black transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
                    <span className={`w-4 h-0.5 bg-black transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
                </button>
            </div>

            {/* Mobile Dropdown Menu */}
            {isMenuOpen && (
                <div className="absolute top-full left-0 w-full bg-white border-b border-black/5 shadow-2xl md:hidden animate-in fade-in slide-in-from-top-2 duration-300">
                    <ul className="flex flex-col items-start gap-5 p-6 list-none m-0">
                        <li>
                            <Link to="/chat" className="text-xl font-bold text-[#D81F26] no-underline" onClick={() => setIsMenuOpen(false)}>
                                Try CarFido
                            </Link>
                        </li>
                        <li>
                            <Link to="/about" className="text-base font-bold text-black/70 no-underline hover:text-black" onClick={() => setIsMenuOpen(false)}>
                                About
                            </Link>
                        </li>
                        <li>
                            <Link to="/blogs" className="text-base font-bold text-black/70 no-underline hover:text-black" onClick={() => setIsMenuOpen(false)}>
                                Blogs
                            </Link>
                        </li>
                        <li>
                            <Link to="/partner" className="text-base font-bold text-black/70 no-underline hover:text-black" onClick={() => setIsMenuOpen(false)}>
                                Partners
                            </Link>
                        </li>
                        <li>
                            <Link to="/contact" className="text-base font-medium text-black/50 no-underline hover:text-black" onClick={() => setIsMenuOpen(false)}>
                                Contact
                            </Link>
                        </li>
                    </ul>
                </div>
            )}
        </nav>
    );
};

export default Header;
